import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import React from 'react';
import { FDAlert } from '@facet-wealth/design';

export const PlannerAlert = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDAlert
      status={'info'}
      description={resource.attr('plannerAlert')}
    />
  );
};

export const MarriageMismatchAlert = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDAlert
      status={'warning'}
      description={resource.attr('marriageMismatchAlert')}
    />
  );
};
